import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "m-md" }
const _hoisted_2 = { class: "page-title" }
const _hoisted_3 = { class: "p-sm pb-md" }

import { ref, computed } from "vue";
import { useRoute } from "vue-router";
import type { ActivityPageDataConfig, ActivityPageDataItemConfig } from "@/types/pages";
import { useI18n } from "vue-i18n";


export default /*#__PURE__*/_defineComponent({
  __name: 'ActivityPage',
  setup(__props) {

const { t } = useI18n();

const route = useRoute();
const activity = computed<string>(() => route.params["activity"] as string);
const currentActivity = computed<ActivityPageDataItemConfig>(
  () => activityData.value[activity.value]
);

const activityData = ref<ActivityPageDataConfig>({
  coffrage: {
    title: "coffrage",
    text: "coffrage_text",
    images: [
      require("@/assets/imgs/activities/coffrage/1.jpg"),
      require("@/assets/imgs/activities/coffrage/2.jpg"),
      require("@/assets/imgs/activities/coffrage/3.jpg"),
      require("@/assets/imgs/activities/coffrage/4.jpg"),
      require("@/assets/imgs/activities/coffrage/5.jpg"),
      require("@/assets/imgs/activities/coffrage/6.jpg"),
      require("@/assets/imgs/activities/coffrage/7.jpg"),
      require("@/assets/imgs/activities/coffrage/8.jpg"),
      require("@/assets/imgs/activities/coffrage/9.jpg")

    ],
  },
  prefabricated: {
    title: "prefabricated",
    text: "prefabricated_text",
    images: [
      require("@/assets/imgs/activities/prefabricated/1.jpg"),
      require("@/assets/imgs/activities/prefabricated/3.jpg"),
      require("@/assets/imgs/activities/prefabricated/4.jpg"),
      require("@/assets/imgs/activities/prefabricated/5.jpg"),
      require("@/assets/imgs/activities/prefabricated/6.jpg"),
      require("@/assets/imgs/activities/prefabricated/7.jpg"),
      require("@/assets/imgs/activities/prefabricated/8.jpg"),
      require("@/assets/imgs/activities/prefabricated/9.jpg")
    ],
  },
  mansory: {
    title: "mansory",
    text: "mansory_text",
    images: [
      require("@/assets/imgs/activities/mansory/1.jpg"),
      require("@/assets/imgs/activities/mansory/2.jpg"),
      require("@/assets/imgs/activities/mansory/3.jpg"),
      require("@/assets/imgs/activities/mansory/4.jpg"),
      require("@/assets/imgs/activities/mansory/5.jpg"),
      require("@/assets/imgs/activities/mansory/6.jpg")
    ],
  },
  steel: {
    title: "steel",
    text: "steel_text",
    images: [
      require("@/assets/imgs/activities/steel/1.jpg"),
      require("@/assets/imgs/activities/steel/2.jpg"),
      require("@/assets/imgs/activities/steel/3.jpg"),
      require("@/assets/imgs/activities/steel/4.jpg"),
      require("@/assets/imgs/activities/steel/5.jpg"),
      require("@/assets/imgs/activities/steel/6.jpg"),
      require("@/assets/imgs/activities/steel/7.jpg"),
      require("@/assets/imgs/activities/steel/8.jpg"),
      require("@/assets/imgs/activities/steel/9.jpg"),
      require("@/assets/imgs/activities/steel/10.jpg")

    ],
  },
});

return (_ctx: any,_cache: any) => {
  const _component_ImgSlider = _resolveComponent("ImgSlider")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h1", _hoisted_2, _toDisplayString(_unref(t)(_unref(currentActivity).title)), 1),
    _createElementVNode("p", _hoisted_3, _toDisplayString(_unref(t)(_unref(currentActivity).text)), 1),
    _createVNode(_component_ImgSlider, {
      items: _unref(currentActivity).images,
      height: "70vh"
    }, null, 8, ["items"])
  ]))
}
}

})